export default __webpack_public_path__ + "static/media/Foto26.483bafad.png";